module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value && _vm.value.values) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.value.values), function(item, index) {
    return _c('tr', [_c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value.values[index]),
        expression: "value.values[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "autocomplete": "new-password",
        "rows": "5",
        "preselect": "",
        "placeholder": "SQL field definition"
      },
      domProps: {
        "value": (_vm.value.values[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.value.values, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeRow(index)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog(true)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog(false)
      }
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "span": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n                                Value\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                Options\n\n                            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9a21ff0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a21ff0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/strings-editor/strings-editor.vue.html
// module id = 1126
// module chunks = 0